import { render, staticRenderFns } from "./clientdashboard-activate.vue?vue&type=template&id=e77e0138&"
import script from "./clientdashboard-activate.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-activate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports